import { render, staticRenderFns } from "./AddMultaOnly.vue?vue&type=template&id=d54609d6&"
import script from "./AddMultaOnly.vue?vue&type=script&lang=js&"
export * from "./AddMultaOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports